import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ImpersonatePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken, setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError('No impersonation token provided');
      return;
    }

    try {
      // Decode the JWT to get user info (without verification - server already verified)
      const payload = JSON.parse(atob(token.split('.')[1]));
      console.log('Impersonation token payload:', payload);

      // Store in sessionStorage (per-tab) so we DON'T overwrite the super-admin's
      // token in localStorage. sessionStorage is scoped to this single tab only.
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('impersonating', 'true');

      // Update auth context
      setToken(token);
      
      // Fetch user data and redirect
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          console.log('Auth/me response status:', res.status);
          if (!res.ok) {
            throw new Error(`Auth failed with status ${res.status}`);
          }
          return res.json();
        })
        .then(userData => {
          console.log('Impersonated user data:', userData);
          setUser(userData);
          navigate('/dashboard', { replace: true });
        })
        .catch((err) => {
          console.error('Impersonation auth/me error:', err);
          setError(`Authentication failed: ${err.message}`);
        });
        
    } catch (err) {
      console.error('Token decode error:', err);
      setError('Invalid impersonation token');
    }
  }, [searchParams, navigate, setToken, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button 
            onClick={() => window.close()}
            className="text-primary hover:underline"
          >
            Close this tab
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Setting up impersonation session...</p>
      </div>
    </div>
  );
}
